module.exports = __webpack_public_path__ + "img/agriculture_info.552208c3.png";